module.exports = __webpack_public_path__ + "img/pobeda-logo.b739abcf.png";